import InputUniqueTextView from './InputUniqueTextView';

export default InputUniqueTextView;
